import type { ReactNode } from 'react';

interface StateMessageProps {
	icon?: string;
	title: string;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

/** Khối thông báo dùng chung cho trạng thái trống / lỗi, viền nét đứt như bản gốc. */
export function StateMessage({
	icon,
	title,
	description,
	action,
	className = '',
}: StateMessageProps) {
	return (
		<div
			className={`flex flex-col items-center gap-2 rounded-panel border border-dashed border-line bg-white/[0.02] px-6 py-9 text-center ${className}`}
		>
			{icon && (
				<span className="text-3xl opacity-70" aria-hidden="true">
					{icon}
				</span>
			)}
			<strong className="text-base text-ink">{title}</strong>
			{description && (
				<p className="max-w-[46ch] text-sm text-muted">{description}</p>
			)}
			{action && <div className="mt-2">{action}</div>}
		</div>
	);
}

interface ErrorStateProps {
	error: unknown;
	onRetry?: () => void;
	className?: string;
}

export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
	const message =
		error instanceof Error ? error.message : 'Đã có lỗi không xác định.';

	return (
		<StateMessage
			icon="⚠"
			title="Không tải được dữ liệu"
			description={message}
			className={className}
			action={
				onRetry && (
					<button
						type="button"
						onClick={onRetry}
						className="rounded-lg bg-accent px-4 py-2 text-sm font-bold text-white transition active:scale-[0.97]"
					>
						Thử lại
					</button>
				)
			}
		/>
	);
}
